import { Component, HostListener, Injector, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { RecaptchaComponent, RecaptchaErrorParameters } from "ng-recaptcha";
import { EnvironmentDataService } from 'src/app/submodules/angular-common/environment-data.service';
import { PageLayoutDataService } from 'src/app/submodules/angular-common/page-layout-data.service';
import { isClassPresentInDomEventTarget } from 'src/app/submodules/angular-common/util';
import { ApiErrorPayload } from 'submodules/engine-common/api-error-payload';
import { SecurityDataService } from '../../../angular-common/security-data.service';
import { FormSettings } from '../../forms/form-settings';
import { PageFormComponent } from '../../forms/page-form.component';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent extends PageFormComponent {

  public this = this;

  public requireRecaptcha: boolean = false; // diventa true all'ennesimo tentativo fallito di login
  public recaptchaToken;
  public passwordSettingExpected;
  public signUpExpected;
  
  constructor(protected _injector: Injector) { 
    super(_injector);
    this._injector.get(PageLayoutDataService).init({
      notMobileMaxWidth: 352,
      layoutType: 1,
      verticallyCentered:true,
      showBreadcrumbs:false})
  }

  async ngOnInit() {
    await super.init();
    this.passwordSettingExpected = this._injector.get(EnvironmentDataService).environment.getValue("passwordSettingExpected");
    this.signUpExpected = this._injector.get(EnvironmentDataService).environment.getValue("signUpExpected");
  }

  @ViewChild('reCaptcha', {static: false}) reCaptcha: RecaptchaComponent;

  @HostListener('document:click', ['$event'])
  private onClick(event) {
    if(isClassPresentInDomEventTarget(event, 'setPassword'))  
      this.setPassword()
    if(isClassPresentInDomEventTarget(event, 'signUp'))  
      this.signUp()
  }

  setPassword(){
    this._injector.get(Router).navigate(['/set-password']);
  }

  signUp(){
    this._injector.get(Router).navigate(['/sign-up']);
  }

  resetPassword(){
    this._injector.get(Router).navigate(['/reset-password']);
  }

  async cancel(){
    this._injector.get(Router).navigate(['/']);
  }

  /** @override */
  protected async _initSettingsHook(): Promise<FormSettings> {
    return {
      fieldsSettings: {
        username: { required: true, allowBlanks: false },
        password: { required: true, allowBlanks: false } //allowBlanks al momento messo qui perchè initAttributes viene eseguito prima dell'associazione dei tipi
      }
    }
  }

  /** @override */
  protected async _setDatasourceHook(): Promise<{ [key: string]: string | number | boolean | (string | number)[] | File | File[] }> {
    return {}
  }
  
  /** @override */
  protected async _submitHook() {
    try {
      await this._injector.get(SecurityDataService).login({
        username: this.currentValues.username as string,
        password: this.currentValues.password as string,
        recaptchaToken: this.recaptchaToken
      })
    } catch (error) {
      if(this.reCaptcha)
        this.reCaptcha.reset()
      
      const errorPayload: ApiErrorPayload = error.error;
      if(errorPayload.status==403 && errorPayload.errorCode == "AUTH.RECAPTCHA_TOKEN_REQUIRED"){
        this.requireRecaptcha = true;
      }
      throw error;
    }
  }

  public onError(errorDetails: RecaptchaErrorParameters): void {
    console.log(`reCAPTCHA error encountered; details:`, errorDetails);
  }
}
